import { render } from "./RoleSelect.vue?vue&type=template&id=6122775f"
import script from "./RoleSelect.vue?vue&type=script&lang=js"
export * from "./RoleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__